var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22,
    fill: "#FDFDFD",
    stroke: "#DADCE3",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9063 29.4147C21.9116 29.4209 21.9177 29.4253 21.923 29.4307C21.9424 29.4511 21.9635 29.4707 21.9847 29.4903C22.0006 29.5045 22.0155 29.5197 22.0323 29.5339C22.0552 29.5535 22.079 29.5713 22.1028 29.59C22.1186 29.6015 22.1336 29.614 22.1495 29.6256C22.1777 29.6451 22.2068 29.6629 22.2358 29.6798C22.2491 29.6878 22.2614 29.6967 22.2746 29.7039C22.3099 29.7234 22.3469 29.7421 22.3839 29.759C22.3918 29.7626 22.3989 29.767 22.4068 29.7706C22.4526 29.7902 22.4984 29.808 22.5469 29.8231C22.6897 29.8694 22.8421 29.8943 23.0007 29.8943C23.1594 29.8943 23.3109 29.8694 23.4546 29.8231C23.5022 29.808 23.5489 29.7902 23.5947 29.7706C23.6026 29.767 23.6097 29.7626 23.6176 29.7599C23.6546 29.743 23.6916 29.7252 23.7278 29.7048C23.741 29.6976 23.7533 29.6887 23.7665 29.6807C23.7956 29.6629 23.8247 29.6451 23.8529 29.6264C23.8688 29.6158 23.8837 29.6033 23.8996 29.5909C23.9234 29.5731 23.9472 29.5544 23.9701 29.5348C23.986 29.5206 24.0018 29.5063 24.0177 29.4912C24.0388 29.4716 24.0591 29.452 24.0794 29.4316C24.0847 29.4262 24.0908 29.4209 24.0961 29.4156L29.1499 23.9617C29.7157 23.3512 29.684 22.3947 29.0794 21.8234C28.4758 21.2521 27.5276 21.2841 26.9619 21.8946L24.4997 24.5517V11.8233C24.4997 10.9877 23.8291 10.3105 23.0016 10.3105C22.1742 10.3105 21.5035 10.9877 21.5035 11.8233V24.5499L19.0414 21.8928C18.4757 21.2824 17.5283 21.2512 16.9238 21.8216C16.3193 22.3929 16.2884 23.3495 16.8533 23.9599L21.9071 29.4138L21.9063 29.4147Z",
    fill: "url(#paint0_linear_310_743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1918 21.5596C33.3643 21.5596 32.6937 22.2367 32.6937 23.0723V32.6649H13.3067V23.0723C13.3067 22.2367 12.6361 21.5596 11.8086 21.5596C10.9812 21.5596 10.3105 22.2367 10.3105 23.0723V34.1776C10.3105 35.0132 10.9812 35.6903 11.8086 35.6903H34.1918C35.0192 35.6903 35.6899 35.0132 35.6899 34.1776V23.0723C35.6899 22.2367 35.0192 21.5596 34.1918 21.5596V21.5596Z",
    fill: "url(#paint1_linear_310_743)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_743",
    x1: 23.0018,
    y1: 10.3105,
    x2: 23.0018,
    y2: 29.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE192D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D529B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_743",
    x1: 23.0002,
    y1: 21.5596,
    x2: 23.0002,
    y2: 35.6903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE192D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D529B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.3793,
    height: 25.3793,
    fill: "white",
    transform: "translate(10.3105 10.3105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.412bc92e99b4e5052d4191fd41523ed0.svg";
export { ForwardRef as ReactComponent };